<section class="main-section">
    <header class="d-block d-md-flex justify-content-between align-items-center main-heading">
        <div class="row align-items-center">
        <div class="d-flex">
          <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button"
            aria-controls="offcanvasExample">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            </svg></a>
          <h3 *ngIf="clientAccountId > 0" class="heading-span visited-heading-span cursor-pointer" [ngClass]="clientAccountName ? 'underline': ''" (click)="navigateToUserCenter()"> User Centre /</h3>
          <h3 *ngIf="clientAccountName" class="heading-span me-2" [ngClass]="clientAccountName ? 'visited-heading-span cursor-pointer underline': ''" (click)="navigateToAdminDetails()"> {{ clientAccountName }} </h3>
          <h3 class="heading-span"> / Transfer School</h3> 
        </div>      
        </div>
      </header>
      <div class="bg-white d-flex justify-content-between align-items-center radius8 mb-3 py-2">
        <div class="content-box w-100" [formGroup]="transferSchoolForm">
          <div class="row">
            <ng-container>
              <div class="col-sm-6 mb-4">
                <span class="black-text fs-14 mb-1"> {{ clientAccountId > 0 ? 'Existing MAT Account' : 'Transfer' }} </span>
                <input type="text" class="form-control" formControlName="existingMatAccountName" [readOnly]="true"/>
              </div>
              <div class="col-sm-6 mb-4">
                <div class="edit-account-selectoption hide-label">
                  <span class="black-text fs-14 mb-1">Select a School</span>
                  <mat-form-field>
                    <mat-label>Schools</mat-label>
                    <mat-select required formControlName="school"
                      placeholder="School"
                      [class.is-invalid]="transferSchoolForm.controls['school'].invalid && transferSchoolForm.controls['school'].touched">
                      @for (school of schoolList; track school) {
                        <mat-option [value]="school.schoolId">{{school.schoolName}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="(transferSchoolForm.controls['school'].invalid && transferSchoolForm.controls['school'].touched) || transferSchoolForm.controls['school'].dirty">
                  <small *ngIf="transferSchoolForm.controls['school'].errors?.['required']" class="text-danger fs-13">School is required</small>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="divider mb-3"></div>
          <h3 class="my-2 content-center blue-text my-2">Select New Account </h3>
      
          <div class="row">
            <ng-container>
              <div class="col-sm-6 mb-4" (click)="onSelectNewMatAccount()">
                <div class="edit-account-selectoption hide-label">
                  <span class="black-text fs-14 mb-1">Account</span>
                  <mat-form-field class="mt-2">
                    <mat-label>New Mat Account</mat-label>
                    <mat-select required formControlName="newMatAccount"
                      placeholder="Account" (selectionChange)="onSelectingAccountToTransfer($event.value)"
                      [class.is-invalid]="transferSchoolForm.controls['newMatAccount'].invalid && transferSchoolForm.controls['newMatAccount'].touched">
                      @for (matAccount of matAccountList; track matAccount) {
                        <mat-option [value]="matAccount.clientAccountId" [style.font-weight]="matAccount.clientAccountId == -1 ? 'bold' : 'normal'">{{matAccount.clientAccountName}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="(transferSchoolForm.controls['newMatAccount'].invalid && transferSchoolForm.controls['newMatAccount'].touched) || transferSchoolForm.controls['newMatAccount'].dirty">
                  <small *ngIf="transferSchoolForm.controls['newMatAccount'].errors?.['required']" class="text-danger fs-13">Account is required</small>
                </div>
              </div>
              <div *ngIf="transferSchoolForm.controls['newMatAccount'].valid" class="col-sm-6 mb-4">
                <div class="edit-account-selectoption hide-label">
                  <div class="d-flex">
                    <span class="black-text fs-14 mt-1">Package</span>
                    <mat-icon class="my-1 fs-22 ms-2" matTooltipPosition="right" matTooltip="Existing school package will be selected automatically. If required, you can switch and customize the package">info</mat-icon>  
                  </div>     
                  <mat-form-field>                 
                    <div class="d-flex">
                      <mat-select required formControlName="package" (selectionChange)="onPackageChange($event.value)"
                        [class.is-invalid]="transferSchoolForm.controls['package'].invalid && transferSchoolForm.controls['package'].touched">
                        @for (package of packageList; track package) {
                          <mat-option [value]="package.packageId">
                            <span class="input-group-text border-0 bg-transparent" id="basic-addon1">
                            </span>{{package.packageName}}
                          </mat-option>
                        }
                      </mat-select>
                      <img src="../../../assets/images/edit.svg" width="15" height="15" alt="edit" class="my-2 clickable-edit" 
                        (click)="$event.stopPropagation(); $event.preventDefault(); editPackage();" />
                    </div>
                  </mat-form-field>
                </div>
                <div *ngIf="(transferSchoolForm.controls['package'].invalid && transferSchoolForm.controls['package'].touched) || transferSchoolForm.controls['package'].dirty">
                  <small *ngIf="transferSchoolForm.controls['package'].errors?.['required']" class="text-danger fs-13">Package is required</small>
                </div>
              </div>
            </ng-container>
          </div>
          <div *ngIf="isEditPackage">
            <ng-container>
              <div class="row">
              <div class="col-sm-6 mb-4">
                <span class="black-text fs-14 mb-1"> New Package Name </span>
                <input type="text" class="form-control" formControlName="newPackageName" required="true"
                  [class.is-invalid]="transferSchoolForm.controls['newPackageName'].invalid && transferSchoolForm.controls['newPackageName'].touched"/>
                <div *ngIf="(transferSchoolForm.controls['newPackageName'].invalid && transferSchoolForm.controls['newPackageName'].touched) || transferSchoolForm.controls['newPackageName'].dirty">
                  <small *ngIf="transferSchoolForm.controls['newPackageName'].errors?.['required']" class="text-danger">New Package Name is required</small>
                  <small *ngIf="transferSchoolForm.controls['newPackageName'].errors?.['pattern']" class="text-danger">Please provide a valid New Package Name</small>
                </div>
              </div>
              <div class="col-sm-6 text-end my-auto">
                <div class="d-flex">
                   <button type="button" class="btn theme-btn-outline px-5" (click)="undoPackageCustomization()">
                    Delete
                  </button>   
                  <mat-icon class="my-1 fs-22 ms-2" matTooltipPosition="right"
                   matTooltip="Clears the customizations done within the selected package">info</mat-icon>                    
                </div>
              </div>
            </div>
            </ng-container>
          </div>
          <div *ngIf="isEditPackage">
            <h3 class="mb-1 content-center blue-text">Update {{ selectedPackage ? ('"' + selectedPackage + '"') : "" }} Package </h3>
            <div class="my-2">
              <span class="black-text fs-14 mb-1">Module</span>
              <mat-form-field>
                <mat-select #select required formControlName="modules" multiple (selectionChange)="onModuleChange($event)">
                  <mat-select-trigger>
                    <span class="chip-list-head">Added Items:</span>
                    <span class="chip-main">
                      <span *ngFor="let moduleValue of transferSchoolForm.controls['modules'].value"
                        class="chip-list">{{moduleValue.moduleName}}
                        <a class="close" (click)="$event.stopPropagation();$event.preventDefault();removeModule(moduleValue)">
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </a>
                      </span>
                    </span>
                    
                    @if ((transferSchoolForm.controls['modules'].value?.length || 0) > 0) {
                      <span class="chip-list count" 
                      (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Modules', packageControl.Module, undefined)">
                        #{{(transferSchoolForm.controls['modules'].value?.length)}}
                      </span>
                    }
                  </mat-select-trigger>
                  @for (module of packageDetails.modules; track module) {
                    <mat-option [value]="module">{{module.moduleName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="my-2">
              <span class="black-text fs-14 mb-1">Sub Category</span>
              <mat-form-field>
                <mat-select #select required formControlName="subCategories" (valueChange)="this.selectedGroupedSubcategories = generateSelectedCategoryModules($event)" multiple>
                  <mat-select-trigger>
                    <span class="chip-list-head">Added Items:</span>
                    <span class="chip-main">
                      <div *ngFor="let rg of selectedGroupedSubcategories | keyvalue" >
                          <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{rg.key}}</h4> 
                            <span style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;" *ngFor="let subCategoryValue of rg.value" 
                            class="chip-list toolkit-display" 
                            title="{{subCategoryValue.subCategoryName}}">
                              <label class="toolkit-display"  >
                                <mat-icon style="font-size: 1.8em;" *ngIf="subCategoryValue.subCategoryDisplayName!=null">short_text</mat-icon>
                                <span class="toolkit-display-text" *ngIf="subCategoryValue.subCategoryDisplayName!=null">{{subCategoryValue.subCategoryDisplayName}}</span>
                                <span class="toolkit-display-name">{{subCategoryValue.subCategoryName}}</span>
                              </label>
                                <a class="close">
                                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                      stroke-linejoin="round" />
                                    <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                                      stroke-linejoin="round" />
                                  </svg>
                                </a>
                              </span>
                        </div>
                    </span>
                    @if ((transferSchoolForm.controls['subCategories'].value?.length || 0) > 0) {
                      <span class="chip-list count" 
                      (click)="$event.stopPropagation();$event.preventDefault();previewPopup('Added Modules', packageControl.SubCategory, undefined)">
                        #{{(transferSchoolForm.controls['subCategories'].value?.length)}}
                      </span>
                    }
                  </mat-select-trigger>
                 <mat-optgroup *ngFor="let rg of (this.groupedSubCategories??{}) | keyvalue" [label]="rg.key">
                      @for (subCategory of rg.value; track subCategory) {
                        <mat-option [class.multiline]="subCategory.subCategoryDisplayName!=null" [value]="subCategory">
                          @if(subCategory.subCategoryDisplayName==null)
                          {
                            {{subCategory.subCategoryName}}
                          }
                          @else {
                          <label class="toolkit-display">
                            <mat-icon >short_text</mat-icon>
                            <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
                            <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                          </label>
                          }
                          
                        </mat-option>
                      }
                  </mat-optgroup> 
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="sticky-btns">
        <div class="row">
          <div class="col-sm-12 text-right">
            <button type="button" class="btn theme-btn-outline px-5" (click)="navigateToAdminDetails()">Cancel</button>           
            <button type="button" class="btn theme-btn px-4 ms-3" (click)="transferSchool()" >Transfer</button>           
          </div>
        </div>
      </div>
</section>